import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface FormChanges {
  stateChanges: Observable<FormChangesArgs>;
}

export interface FormChangesArgs {
  type: string;
  properties: { [key: string]: any; }
}

@Injectable({
  providedIn: 'root'
})
export class FormChangesService implements FormChanges {

  private _stateChanges = new Subject<FormChangesArgs>();
  public stateChanges: Observable<FormChangesArgs> ;

  constructor() {
    this.stateChanges = this._stateChanges.asObservable();
  }

  public markAsTouched(args?: any): void {
    this._stateChanges.next({type: 'touched', properties: args});
  }

}